// extracted by mini-css-extract-plugin
module.exports = {"userType":"UserType_userType__3DNm6","block":"UserType_block__2eDOA","title":"UserType_title__AKX13","userTypeBlock":"UserType_userTypeBlock__3raiQ"};